import PaymentMethods from './PaymentMethods'

export default PaymentMethods
